export function canDefinitionContain(parentNodeType, childNodeType) {
  const parent = String(parentNodeType || "").toLowerCase();
  const child = String(childNodeType || "").toLowerCase();

  if (!parent || !child) return false;

  if (parent === "project") {
    return ["module", "element", "hardware"].includes(child);
  }

  if (parent === "module") {
    return ["element", "hardware"].includes(child);
  }

  if (parent === "element") {
    return ["element", "hardware"].includes(child);
  }

  if (parent === "hardware") {
    return ["hardware"].includes(child);
  }

  return false;
}